import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Sparkles, CheckCircle2 } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
export function WelcomePage() {
  const navigate = useNavigate();
  const {
    user
  } = useAuth();
  return <div className="min-h-screen bg-aliceBlue flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-1444">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="sm:mx-auto sm:w-full sm:max-w-lg" data-id="element-1445">
        <div className="bg-white py-12 px-6 shadow-sm sm:rounded-xl sm:px-12 border border-borderColor text-center" data-id="element-1446">
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-aliceBlue mb-6" data-id="element-1447">
            <Sparkles className="h-8 w-8 text-violetBlue" data-id="element-1448" />
          </div>
          <h2 className="text-3xl font-bold text-primary mb-4" data-id="element-1449">
            Welcome{user?.name ? `, ${user.name.split(' ')[0]}` : ''}
          </h2>
          <p className="text-lg text-secondary mb-8" data-id="element-1450">
            Let's set up your Legal Health Check. We'll ask a few quick
            questions to personalize your experience — this takes about 2
            minutes.
          </p>

          <button onClick={() => navigate('/onboarding/profile')} className="w-full flex justify-center py-4 px-4 border border-transparent rounded-lg shadow-sm text-lg font-semibold text-white bg-violetBlue hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violetBlue transition-opacity mb-8" data-id="element-1451">
            Continue
          </button>

          <div className="flex flex-col items-center gap-3 text-sm text-secondary" data-id="element-1452">
            <div className="flex items-center gap-2" data-id="element-1453">
              <CheckCircle2 className="w-4 h-4 text-turquoise" data-id="element-1454" />
              <span data-id="element-1455">Takes 2 minutes</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-1456">
              <CheckCircle2 className="w-4 h-4 text-turquoise" data-id="element-1457" />
              <span data-id="element-1458">Your answers are saved automatically</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-1459">
              <CheckCircle2 className="w-4 h-4 text-turquoise" data-id="element-1460" />
              <span data-id="element-1461">You can update anytime</span>
            </div>
          </div>
        </div>
      </motion.div>
    </div>;
}